import { EpicIcons, Icon, Tooltip, TooltipPosition } from "@constellation-academy/epic-ui";
import { useState } from "react";
import { useTranslation } from "@i18n/hooks";
import { cx } from "@styled-system/css";
import { wrapperClass } from "./id-display-field.styles";
import { type IdDisplayFieldProps } from "./id-display-field.types";

export const IdDisplayField = ({ id, label = "ID", className }: IdDisplayFieldProps) => {
	const [isCopied, setIsCopied] = useState(false);
	const domId = `${CSS.escape(id)}-id-display-field`;
	const { t } = useTranslation("common");

	const handleOnClick = async () => {
		if (id) {
			await navigator.clipboard.writeText(id);
			setIsCopied(true);
			setTimeout(() => {
				setIsCopied(false);
			}, 2500);
		}
	};

	return (
		<>
			<Tooltip
				target={`#${domId}`}
				position={TooltipPosition.Right}
				autoHide
				content={`${label} ${t("actions.copy")}`}
			/>
			<button
				type="button"
				id={domId}
				className={cx(wrapperClass, className)}
				onClick={handleOnClick}
			>
				{label} <Icon icon={isCopied ? EpicIcons.CHECK : EpicIcons.COPY} sizeRem={0.8} />
			</button>
		</>
	);
};
